import { render } from "./SalesChannels.vue?vue&type=template&id=a98ae84e&ts=true"
import script from "./SalesChannels.vue?vue&type=script&lang=ts"
export * from "./SalesChannels.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-merchant-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__